export default __webpack_public_path__ + "static/media/search_top_institution_image.e75f5d3b.svg";